// extracted by mini-css-extract-plugin
export var bodyRow = "_cb-d";
export var cardColumns = "_cb-e";
export var ellipsesOverflow = "_cb-2";
export var flatBottomCorners = "_cb-3";
export var flatTopCorners = "_cb-4";
export var headerActionsDropdown = "_cb-f";
export var headerBottomRow = "_cb-c";
export var headerTopRow = "_cb-b";
export var orderDetailsWrapper = "_cb-0";
export var orderInfoContainer = "_cb-1";
export var productDetails = "_cb-9";
export var productImage = "_cb-5";
export var responsiveTable = "_cb-8";
export var shipmentContainer = "_cb-a";
export var tableBottomLeft = "_cb-6";
export var tableBottomRight = "_cb-7";
export var trackingLink = "_cb-g";